<div class="w-full h-full pdf-container"
(mouseenter)="showToolbar()"
(mouseleave)="hideToolbar()"
(touchstart)="showToolbar()"
>

<!-- [customToolbar]="additionalButtons" -->
  <ngx-extended-pdf-viewer
  [src]="pdfUrl"
  [textLayer]="true"
  (pdfLoaded)="afterLoadComplete($event)"
  (pageChange)="pagechanging($event)"
  delayFirstView="500"
  (pdfLoadingFailed)="onError($event)"
  (pagesLoaded)="onPagesLoaded($event)"
  (pageRendered)="onpageRendered('pageRendered', $event)"
  [(pageViewMode)]="pageViewMode"
  [(scrollMode)]="scrollMode"
  [page]="currentPage"
  height="100%"
  class="h-full block"
  [zoom]="zoom"
  >
  </ngx-extended-pdf-viewer>

  <div class="custom-toolbar"
  [class.toolbar-visible]="isToolbarVisible"
  >
    <!-- <div class="progress-bar" [style.width.%]="progressPercentage"></div> -->

    <div class="flex justify-between items-center gap-5">
      <button class="nav-button" (click)="toggleSidebar()">
         <ion-icon name="list" class="text-xl  leading-6 md:text-3xl md:leading-8"></ion-icon>
      </button>

      <div class="flex justify-center items-center gap-5">
        <!-- Botón página anterior -->
        <button class="nav-button" (click)="previousPage()" [disabled]="currentPage <= 1">
          <mat-icon class="mdi mdi-chevron-left text-xl  leading-6 md:text-3xl md:leading-8"></mat-icon>
        </button>

        <!-- Contador de páginas -->
        <span class="page-counter">{{ currentPage }} / {{ totalPages }}</span>

        <!-- Botón página siguiente -->
        <button class="nav-button" (click)="nextPage()" [disabled]="currentPage >= totalPages">
          <mat-icon class="mdi mdi-chevron-right text-xl  leading-6 md:text-3xl md:leading-8"></mat-icon>
        </button>
      </div>

      <div class="flex justify-center items-center gap-5">
        <button *ngIf="pageViewMode === 'multiple'" class="nav-button" (click)="changeViewMode('single')">
          <ion-icon name="document" class="text-lg  leading-5 md:text-2xl md:leading-7"></ion-icon>
        </button>

        <button *ngIf="pageViewMode === 'single'" class="nav-button" (click)="changeViewMode('multiple')">
          <mat-icon class="mdi mdi-page-layout-header-footer text-lg  leading-5  md:text-2xl md:leading-7"></mat-icon>
        </button>

        <button *ngIf="displayFullscreen" class="nav-button" (click)="toggleFullscreen()">
          <ion-icon *ngIf="!isfullscreen" name="scan-outline" class="text-xl  leading-6 md:text-3xl md:leading-8" ></ion-icon>
          <ion-icon *ngIf="isfullscreen" name="contract" class="text-xl  leading-6 md:text-3xl md:leading-8" ></ion-icon>
        </button>
      </div>

    </div>

  </div>
</div>

